import { createApi } from "@reduxjs/toolkit/query/react";

import { ApiRoutes } from "../constants/ApiRoutes";
import { fetchQuery } from "../helpers/ApiHelpers";
import { createUrl } from "../utils";

enum StrategyApiTypes {
  StrategyPromoList = "strategy-promo-list",
  PersonalData = "personal-data",
}

export const strategyApi = createApi({
  reducerPath: "strategyApi",
  baseQuery: fetchQuery(),
  tagTypes: [StrategyApiTypes.StrategyPromoList, StrategyApiTypes.PersonalData],
  endpoints: (builder) => ({
    strategyPromoList: builder.query<
      Application.ResponseProps<Strategy.StrategyPromoProps[]>,
      void
    >({
      query: () => ApiRoutes.StrategyPromoList,
      providesTags: [StrategyApiTypes.StrategyPromoList],
    }),
    strategyAgreementList: builder.query<
      Application.ResponseProps<Strategy.AgreementContractBuyStrategy>,
      Strategy.RequestGetAgreements
    >({
      query: (data) => createUrl(ApiRoutes.StrategyGetAgreement, { query: data }),
    }),
    generateSmsBuyPromoStrategy: builder.mutation<void, Application.QueryWithActionId>({
      query: (data) => createUrl(ApiRoutes.StrategyGenerateSmsPromoStrategy, { query: data }),
    }),
    confirmSmsBuyPromoStrategy: builder.mutation<void, Application.QueryWithActionIdAndCode>({
      query: (data) => createUrl(ApiRoutes.StrategySignSmsPromoStrategy, { query: data }),
      invalidatesTags: [StrategyApiTypes.PersonalData],
    }),
    getErrorByStrategy: builder.query<Application.ResponseProps<{ idStrategy?: string }>, void>({
      query: () => ApiRoutes.StrategyGetErrorByBuyStrategy,
    }),
    getDataWithErrorByStrategy: builder.query<
      Application.ResponseProps<Strategy.ErrorPersonalData>,
      void
    >({
      query: () => ApiRoutes.StrategyGetPersonalDataWithError,
      providesTags: [StrategyApiTypes.PersonalData],
    }),
    saveDataWithErrorByStrategy: builder.mutation<
      Application.ResponseWithActionId,
      Strategy.SaveFixPersonalData
    >({
      query: (data) => ({
        url: ApiRoutes.StrategySavePersonalDataWithFix,
        body: data,
        method: "POST",
      }),
    }),
    getStrategyForSign: builder.query<Application.ResponseProps<Strategy.StrategyForSign>, void>({
      query: () => ApiRoutes.StrategyListForSign,
    }),
  }),
});

export const {
  useGetStrategyForSignQuery,
  useConfirmSmsBuyPromoStrategyMutation,
  useStrategyPromoListQuery,
  useSaveDataWithErrorByStrategyMutation,
  useLazyStrategyAgreementListQuery,
  useGenerateSmsBuyPromoStrategyMutation,
  useStrategyAgreementListQuery,
  useGetErrorByStrategyQuery,
  useLazyGetErrorByStrategyQuery,
  useGetDataWithErrorByStrategyQuery,
} = strategyApi;
